import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { Hint } from '../../partials/Field';
export var CheckboxBlock = styled.div.withConfig({
  displayName: "CheckboxBlock",
  componentId: "sc-1ut5043-0"
})(["", ";+ ", "{margin-top:8px;}input{display:none;}label{display:inline-block;display:", ";position:relative;width:100%;padding-left:30px;cursor:pointer;", ";&:before,&:after{position:absolute;top:2px;left:0;width:21px;height:21px;border-radius:", ";content:'';}&:before{border:1px solid ", ";background-color:#fff;}&:after{opacity:0;content:'';background-color:", ";transition:opacity 0.15s ease;}svg{position:absolute;z-index:1;top:5px;left:3px;opacity:0;color:#fff;}}input:checked + label{&:after,svg{opacity:1;}}input:disabled + label{cursor:not-allowed;}"], function (_ref) {
  var withLabel = _ref.withLabel;
  return !withLabel ? 'width: 24px; height: 24px;' : '';
}, Hint, function (_ref2) {
  var withLabel = _ref2.withLabel;
  return withLabel ? 'inline-block' : 'block';
}, getFont(0), function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme,
    disabled = _ref4.disabled;
  return disabled ? theme.colors.terciaryM : theme.checkboxColor || theme.checkboxActiveColor || theme.mainColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.checkboxActiveColor || theme.mainColor;
});